import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReadMoreComponent} from './read-more.component';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
  ],
  declarations: [ReadMoreComponent],
  exports: [ReadMoreComponent]
})
export class ReadMoreModule {
}
